import { render } from "./shop_reviews_item.vue?vue&type=template&id=5d74ed4c&scoped=true"
import script from "./shop_reviews_item.vue?vue&type=script&lang=js"
export * from "./shop_reviews_item.vue?vue&type=script&lang=js"

import "./shop_reviews_item.vue?vue&type=style&index=0&id=5d74ed4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d74ed4c"]])

export default __exports__